// extracted by mini-css-extract-plugin
module.exports = {"productCardBuilderWrapper":"ProductCard_productCardBuilderWrapper__wNHey"};